<template>
  <div class="agent-actions-container" ref="menuRef">
    <button @click="toggleMenu" class="action-trigger" :class="{ 'active': isOpen }" ref="triggerRef">
      <div class="avatar-circle">
         <img :src="formattedAvatar" alt="Bot" />
      </div>
      <span class="trigger-label">Gérer l'Agent</span>
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="trigger-icon"
      >
        <polyline points="6 9 12 15 18 9"></polyline>
      </svg>
    </button>

    <Teleport to="body">
      <transition name="dropdown-fade">
        <div v-if="isOpen" class="dropdown-menu" ref="dropdownRef" :style="dropdownStyle">
          <!-- Header -->
          <div class="menu-header">
               <div class="header-avatar">
                  <img :src="formattedAvatar" alt="Bot" />
               </div>
               <div class="header-info">
                  <p class="header-name">{{ chatbotName || 'Mon Agent' }}</p>
                  <p class="header-id">ID: {{ chatbotId.substring(0, 8) }}...</p>
               </div>
          </div>

          <div class="menu-content">
              <!-- Section: Développement -->
              <div class="menu-section">
                  <div class="section-label">Développement</div>
                  
                  <router-link :to="`/dashboard/chatbots/${chatbotId}/playground`" class="menu-item" @click="isOpen = false">
                     <div class="item-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="5 3 19 12 5 21 5 3"></polygon></svg>
                     </div>
                     <div class="item-content">
                        <span class="item-title">Entraîner mon agent</span>
                        <span class="item-subtitle">Développer le scenario</span>
                     </div>
                  </router-link>
              </div>

              <!-- Section: Déploiement -->
              <div class="menu-section">
                  <div class="section-label">Déploiement</div>

                  <router-link :to="`/dashboard/chatbots/${chatbotId}/integration/widget`" class="menu-item" @click="isOpen = false">
                     <div class="item-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
                     </div>
                     <div class="item-content">
                        <span class="item-title">Site Web</span>
                        <span class="item-subtitle">Widget chat</span>
                     </div>
                     <span v-if="isFree" class="badge-pro">Pro</span>
                     <span v-else class="badge-new">NEW</span>
                  </router-link>

                  <button @click="handleWhatsAppClick" class="menu-item w-full text-left">
                     <div class="item-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.525 3.488"/></svg>
                     </div>
                     <div class="item-content">
                        <span class="item-title">WhatsApp</span>
                        <span class="item-subtitle" :class="isWhatsAppConnected ? 'text-green' : 'text-gray'">
                          {{ isWhatsAppConnected ? 'Connecté' : 'Non configuré' }}
                        </span>
                     </div>
                     <span v-if="isFree" class="badge-pro">Pro</span>
                  </button>
              </div>

              <!-- Section: Statistiques -->
              <div class="menu-section">
                  <div class="section-label">Statistiques</div>

                  <button @click="handleDauClick" class="menu-item" :class="{ 'item-active': isDauActive }">
                     <div class="item-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                     </div>
                     <div class="item-content">
                        <span class="item-title">Utilisateurs Actifs</span>
                        <span class="item-subtitle">DAU - 3 derniers jours</span>
                     </div>
                     <div v-if="isDauActive" class="active-dot"></div>
                  </button>
              </div>
          </div>

          <!-- Footer -->
          <div class="menu-footer">
               <router-link :to="`/dashboard/chat/${chatbotId}`" class="live-chat-btn" @click="isOpen = false">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                Live Chat
              </router-link>
          </div>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
import axios from 'axios';
import { apiBaseUrl } from '@/config';

export default {
  name: 'AgentActionsMenu',
  props: {
    chatbotId: {
      type: String,
      required: true
    },
    chatbotName: {
      type: String,
      default: ''
    },
    chatbotAvatar: {
      type: String,
      default: null
    },
    isWhatsAppConnected: {
      type: Boolean,
      default: false
    },
    isDauActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      dropdownStyle: {},
      isFree: false
    }
  },
  computed: {
    formattedAvatar() {
      // 1. Handle legacy default
      if (this.chatbotAvatar === '/avatars/bot1.png') {
        const seed = this.chatbotName || this.chatbotId || 'bot';
        return `https://api.dicebear.com/9.x/bottts-neutral/svg?seed=${encodeURIComponent(seed)}`;
      }
      
      // 2. Handle existing avatar
      if (this.chatbotAvatar && this.chatbotAvatar.trim() !== '') {
        if (this.chatbotAvatar.startsWith('http')) {
          return this.chatbotAvatar;
        }
        return `https://api.peelo.io/public/${this.chatbotAvatar}`;
      }

      // 3. Fallback (DiceBear)
      const seed = this.chatbotName || this.chatbotId || 'bot';
      return `https://api.dicebear.com/9.x/bottts-neutral/svg?seed=${encodeURIComponent(seed)}`;
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
    window.addEventListener('scroll', this.updateDropdownPosition, true)
    window.addEventListener('resize', this.updateDropdownPosition)
    this.fetchPlan()
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('scroll', this.updateDropdownPosition, true)
    window.removeEventListener('resize', this.updateDropdownPosition)
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.$nextTick(() => {
          this.updateDropdownPosition()
        })
      }
    },
    updateDropdownPosition() {
      if (!this.$refs.triggerRef || !this.isOpen) return;
      const rect = this.$refs.triggerRef.getBoundingClientRect();
      this.dropdownStyle = {
        position: 'fixed',
        top: `${rect.bottom + 8}px`,
        right: `${window.innerWidth - rect.right}px`,
        zIndex: 99999
      }
    },
    handleClickOutside(event) {
      const triggerEl = this.$refs.triggerRef;
      const dropdownEl = this.$refs.dropdownRef;
      
      if (triggerEl && triggerEl.contains(event.target)) return;
      if (dropdownEl && dropdownEl.contains(event.target)) return;
      
      this.isOpen = false;
    },
    handleWhatsAppClick() {
      this.isOpen = false;
      this.$emit('open-whatsapp');
    },
    handleDauClick() {
      this.isOpen = false;
      this.$emit('toggle-dau');
    },
    async fetchPlan() {
      try {
        const raw = JSON.parse(localStorage.getItem('user') || '{}');
        const token = (raw && raw.data && raw.data.token) || raw.token;
        if (!token) return;
        const { data } = await axios.get(`${apiBaseUrl}/strong/billing/my-plan`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (data && data.success && data.plan_slug) this.isFree = (data.plan_slug === 'connect');
      } catch (e) { /* silencieux : pas de badge si plan inconnu */ }
    }
  }
}
</script>

<style scoped>
/* Container & Trigger */
.agent-actions-container {
  position: relative;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.action-trigger {
  display: flex;
  align-items: center;
  gap: 12px;
  background: white;
  border: 1px solid #e5e7eb;
  padding: 6px 16px 6px 6px;
  border-radius: 9999px; /* Pill shape */
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
  color: #374151;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.action-trigger:hover, .action-trigger.active {
  background: #f9fafb;
  border-color: #d1d5db;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  transform: translateY(-1px);
}

.avatar-circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

.avatar-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.trigger-label {
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.01em;
}

.trigger-icon {
  color: #9ca3af;
  transition: transform 0.2s ease;
}

.action-trigger.active .trigger-icon {
  transform: rotate(180deg);
}

/* Dropdown Menu (rendered via Teleport on body) */
.dropdown-menu {
  width: 280px;
  background: white;
  border-radius: 24px;
  box-shadow: 
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05),
    0 0 0 1px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transform-origin: top right;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

/* Header */
.menu-header {
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f9fafb;
  border-bottom: 1px solid #f3f4f6;
}

.header-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  padding: 2px;
  background: white;
  border: 1px solid #e5e7eb;
  flex-shrink: 0;
  overflow: hidden;
}

.header-avatar img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.header-info {
  min-width: 0;
}

.header-name {
  font-weight: 700;
  color: #111827;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
}

.header-id {
  font-size: 12px;
  color: #6b7280;
  margin: 2px 0 0 0;
}

/* Content */
.menu-content {
  padding: 12px;
}

.menu-section {
  margin-bottom: 12px;
}

.menu-section:last-child {
  margin-bottom: 0;
}

.section-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #9ca3af;
  font-weight: 700;
  padding: 8px 12px 4px;
}

/* Items */
.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  text-decoration: none;
  color: #374151;
  transition: all 0.2s ease;
  border: none;
  background: transparent;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
}

.menu-item:hover {
  background: #f3f4f6;
}

.item-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4b5563; /* Gray-600 */
  flex-shrink: 0;
  transition: all 0.2s;
}

.menu-item:hover .item-icon {
  color: #111827; /* Gray-900 */
  transform: scale(1.05);
}

.item-content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  text-align: left;
}

.item-title {
  font-weight: 500;
  font-size: 14px;
  color: #1f2937;
}

.item-subtitle {
  font-size: 12px;
  color: #6b7280;
}

.text-green { color: #16a34a; }
.text-gray { color: #9ca3af; }

.badge-new {
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: #10b981;
  padding: 2px 6px;
  border-radius: 6px;
  letter-spacing: 0.05em;
}

.badge-pro {
  font-size: 10px;
  font-weight: 900;
  color: #DAFFD1;
  background: #143028;
  padding: 2px 8px;
  border-radius: 9999px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

/* Active state for toggle items */
.item-active {
  background: #f0fdf4;
}

.item-active .item-icon {
  color: #16a34a;
}

.item-active .item-title {
  color: #15803d;
}

.active-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #16a34a;
  flex-shrink: 0;
  animation: pulse-dot 2s infinite;
}

@keyframes pulse-dot {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Footer */
.menu-footer {
  padding: 16px;
  background: #f9fafb;
  border-top: 1px solid #f3f4f6;
}

.live-chat-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px;
  border-radius: 12px;
  background: white;
  border: 1px solid #e5e7eb;
  color: #374151;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.live-chat-btn:hover {
  background: #10b981;
  border-color: #059669;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(16, 185, 129, 0.4);
}

/* Animations */
.dropdown-fade-enter-active,
.dropdown-fade-leave-active {
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.dropdown-fade-enter-from,
.dropdown-fade-leave-to {
  opacity: 0;
  transform: scale(0.95) translateY(-5px);
}

.dropdown-fade-enter-to,
.dropdown-fade-leave-from {
  opacity: 1;
  transform: scale(1) translateY(0);
}
</style>
